'use strict';

module.exports = function every(fn) {
  return this.items.map(function (item, index) {
    return fn(item, index);
  }).indexOf(false) === -1;
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/every.js
// module id = 1160
// module chunks = 2